import React, { useState } from "react";
import Styles from "./AdminHeader.module.scss";
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import clsx from "clsx";
import {
  adminHome,
  adminNews,
  adminUser,
  adminHistory,
  adminVoucher,
  adminVoucherHistory,
  adminRateLimit,
  adminChat,
  adminItemUsage,
  adminTopUp,
} from "../../Api/SubUrl";
import { NavLink } from "react-router-dom";
// import logo from '../../Css/img/logo.png'
import { CiMenuBurger, CiMenuKebab } from "react-icons/ci";

import Nav from "react-bootstrap/Nav";
import { CiSignpostDuo1, CiAlignBottom } from "react-icons/ci";

import { useLocation } from "react-router-dom";
function AdminHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { pathname } = useLocation();
  const handleClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <Navbar className={clsx(Styles.Navbar)}>
      <Container
        className={clsx(
          Styles.Container,
          "d-flex justify-content-between container-fluid"
        )}
        fluid
      >
        <Navbar.Toggle
          onClick={() => handleClick()}
          className={clsx(Styles.menuBrand)}
          aria-controls="basic-navbar-nav"
        >
          <CiMenuKebab className={clsx(Styles.iconLogo)} />
          <CiMenuBurger className={clsx(Styles.iconLogo)} />
        </Navbar.Toggle>
        {isMenuOpen ? (
          <Navbar.Collapse
            id="basic-navbar-nav"
            className={clsx(Styles.menuHorizontalWrap)}
          >
            <Nav className={clsx(Styles.menuHorizontal, "me-auto")}>
              <NavLink
                to={adminHome}
                onClick={() => handleClick()}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminHome ? Styles.active : ""
                )}
              >
                <CiAlignBottom className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>Thống Kê</span>
              </NavLink>

              <NavLink
                onClick={() => handleClick()}
                to={adminNews}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminNews ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>Bảng Tin</span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminUser}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminUser ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>Người dùng</span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminHistory}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminHistory ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>Lịch sử</span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminVoucher}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminVoucher ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>Khuyến mãi</span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminVoucherHistory}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminVoucherHistory ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>
                  Lịch sử khuyến mãi
                </span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminRateLimit}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminRateLimit ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>
                  Tài khoản bị khóa
                </span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminChat}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminChat ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>
                  Quản lý trò chuyện
                </span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminItemUsage}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminItemUsage ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>
                  Ghi nhận vật phẩm
                </span>
              </NavLink>
              <NavLink
                onClick={() => handleClick()}
                to={adminTopUp}
                className={clsx(
                  Styles.itemNav,
                  pathname === adminTopUp ? Styles.active : ""
                )}
              >
                <CiSignpostDuo1 className={clsx(Styles.iconItem)} />
                <span className={clsx(Styles.itemContent)}>
                  Ghi nhận thẻ nạp
                </span>
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        ) : (
          <></>
        )}
      </Container>
    </Navbar>
  );
}

export default AdminHeader;
